export default "__VITE_ASSET__DLpQ6oYN__"